module.exports = __webpack_public_path__ + "static/img/pop_ico01.2990f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/pop_ico01.png
// module id = Hn5J
// module chunks = 1